/**
 * Configuración de la URL base de la API
 * 
 * Esta función detecta automáticamente el entorno en tiempo de ejecución:
 * - Si estás en localhost → usa BD local (http://localhost/ligaincom)
 * - Si estás en producción (grupo.us.es) → usa BD producción (https://grupo.us.es/ligaincom)
 * 
 * Prioridad de detección:
 * 1. Variable de entorno REACT_APP_API_BASE_URL (tiene máxima prioridad, se inyecta en build time)
 * 2. Detección automática basada en window.location.hostname (runtime)
 * 3. Valores por defecto según el entorno
 */

// Función para obtener la URL base de la API
function getApiBaseUrl() {
  // Prioridad 1: Si hay una variable de entorno definida en build time, usarla
  // (Esto se inyecta cuando haces npm run build con REACT_APP_API_BASE_URL)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Prioridad 2: Detección automática en tiempo de ejecución basada en el hostname
  // Esto funciona tanto en desarrollo como en producción
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || 
                        hostname === '127.0.0.1' ||
                        hostname === '' ||
                        hostname === '::1';
    
    // Si NO es localhost, asumimos que estamos en producción
    if (!isLocalhost) {
      // Verificar si el hostname contiene el dominio de producción
      if (hostname.includes('grupo.us.es') || hostname.includes('ligaincom')) {
        return 'https://grupo.us.es/ligaincom';
      }
      // Si estamos en otro dominio que no es localhost, usar producción por defecto
      return 'https://grupo.us.es/ligaincom';
    }
  }
  
  // Prioridad 3: Default para desarrollo local
  return 'http://localhost/ligaincom';
}

// Exportar la URL base de la API
export const API_BASE_URL = getApiBaseUrl();
